import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '../components';
const logo = `${process.env.PUBLIC_URL}/assets/images/logo.png`;

export default class Logo extends PureComponent {
  render() {
    return (
      <Link to="/">
        <Image className="logo-component" src={logo} alt={process.env.REACT_APP_WEBSITE_NAME} />
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo.js